import { usePageLock } from 'contexts/page-lock/usePageLock';
import SectionParameterSettings from 'features/section-parameter-settings/SectionParameterSettings';

function SiteConfigLayoutsSectionParameters() {
  const { state: lockState } = usePageLock();
  const { isReadOnly } = lockState.publishing;

  return <SectionParameterSettings isReadOnly={isReadOnly} />;
}

export default SiteConfigLayoutsSectionParameters;
